module.exports = __webpack_public_path__ + "static/media/dataUserWarnig.4daf975d.svg";